<template>
  <div>
    <h2 class="text-center">Tax Engine</h2>
    <div class="auth-container">
      <div class="auth-card">
        <h2 class="text-center">Login</h2>

        <form @submit.prevent="login">
          <div class="mb-3">
            <label class="form-label">User Name</label>
            <input
              type="text"
              class="form-control"
              v-model="username"
              placeholder="User Name"
              required
            />
          </div>
          <div class="mb-3">
            <label class="form-label">Password</label>
            <input
              type="password"
              class="form-control"
              v-model="password"
              placeholder="Password"
              required
            />
          </div>

          <div v-if="errorMessage" class="text-danger">
            {{ errorMessage }}
          </div>

          <button type="submit" class="btn btn-primary w-100 mt-3">Login</button>

          <div v-if="loading" class="loader-overlay">
            <div class="loader"></div>
          </div>
        </form>

        <p class="text-center mt-3">
          Don't have an account?
          <router-link to="/signup" class="text-decoration-none">Sign Up</router-link>
        </p>
      </div>
      <div class="modal fade" id="successModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content text-center p-4">
            <div class="modal-body">
              <i class="bi bi-check-circle-fill text-success" style="font-size: 50px"></i>
              <!-- <h4 class="text-success mt-3">Success!</h4> -->
              <p>{{ successMessage }}</p>
              <button class="btn btn-success mt-3" data-bs-dismiss="modal">OK</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { loginUser } from "../End Points/api";
import bootstrap from "bootstrap/dist/js/bootstrap.bundle.min";
export default {
  data() {
    return {
      username: "",
      password: "",
      errorMessage: "",
      successMessage: "",
      loading: false,
    };
  },

  methods: {
    async login() {
      this.errorMessage = "";
      this.successMessage = "";
      this.loading = true;

      try {
        const userdata = {
          username: this.username,
          password: this.password,
        };

        const res = await loginUser(userdata);
        const token = res.data.access_token;
        if (!res) {
          this.loading = true;
        }
        if (token) {
          if (token) {
            this.$store.dispatch("login", token);
            this.$router.push("/");
          }
        }
      } catch (err) {
        console.log("Error while user login:", err);

        if (err.response) {
          const message = err.response.data.message;

          if (message === "User is not approved by admin.") {
            this.successMessage =
              "Your request has been sent. Please wait for admin approval.";
            this.showSuccessModal();
          } else {
            this.errorMessage = "Invalid username or password .";
          }
        } else {
          this.errorMessage = "Something went wrong. Please try again.";
        }
      } finally {
        this.loading = false;
      }
      this.username = "";
      this.password = "";
    },

    showSuccessModal() {
      const modal = new bootstrap.Modal(document.getElementById("successModal"));
      modal.show();
    },
  },
};
</script>

<style scoped>
.text-success {
  color: green;
  font-weight: bold;
}

.text-danger {
  color: red;
  font-weight: bold;
  padding: 10px;
  background-color: rgb(239, 205, 205);
  border-radius: 5px;
}

.auth-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 20px;
  background: linear-gradient(to right, #667eea, #764ba2);
}

.auth-card {
  width: 100%;
  max-width: 400px;
  background: #fff;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.btn-primary {
  background: #764ba2;
  border: none;
  transition: 0.3s;
}
.btn-primary:hover {
  background: #5b2a86;
}

@media (max-width: 768px) {
  .auth-card {
    padding: 20px;
  }
}

.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loader {
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>